module.exports = __webpack_public_path__ + "img/logo2.d415f08a.svg";